// helper object for setting up NoUI sliders
let sliders = {
    inputs: [],
    init: function(id, options) {
        // create the slider
        this.inputs[id] = noUiSlider.create(
            document.querySelector('#slider__' + id),
            options
        );
        //set up handlers
        if( typeof( options.start ) == 'number' ) {
            // update label (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function(value) {
                document.getElementById('slider-value__' + id).innerHTML = +value;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function(value) {
                Spruce.store('inputs').set(id, +value);
            }, 100));
        } else {
            // update labels (using getElementById.innerHTML for performance)
            this.inputs[id].on('update', function (values, handle) {
                let v = +values[handle];
                let suffix = '';

                // special case for value
                if( id === 'value' ) {
                    // add a suffix of K or M
                    suffix = +values[handle] < 1  ? 'K' : 'M';

                    // multiply by 1000 if < 1 million as we'll be displaying 1000s
                    v = v < 1 ? v * 1000 : v;

                    // if it's the last handle and 100m then add a + to signify this will also match anything over this
                    if( handle === 1 && +values[handle] === 100 ) {
                        suffix+= '+';
                    }
                }

                document.getElementById('slider-value-' + (handle === 0 ? 'min' : 'max') + '__' + id).innerHTML = v + suffix;
            });
            // update Store (debounced for performance)
            this.inputs[id].on('update', _.debounce( function (values, handle) {
                let current = Spruce.store('inputs').current[id];
                if (handle === 0) {
                    Spruce.store('inputs').set( id, {
                        min: +values[handle],
                        max: +current.max
                    });
                } else {
                    Spruce.store('inputs').set(id, {
                        min: +current.min,
                        max: +values[handle]
                    });
                }
            }, 100));
        }
    },
    set: function(id, value) {
        this.inputs[id].set(value);
    },
    updateOptions: function(id, newOptions) {
        this.inputs[id].updateOptions(newOptions, false);
    }
};

// The graphs Alpine object and other associated constants
window.appGraphs = () => {
    return {
        resultsLoading: false,  // track whether the search results are loading or not
        showAllResults: false,  // show names for all the results or not
        activePlayer: null, // popup for player details
        graphIsActive: false, // popup for graph
        graphData: null,

        router: function(state) {
            /*
             * Do nothing is the state is not defined
             */
            if( typeof(state) === 'undefined') {
                return;
            }

            /*
             * if we're at the root then no need to do anything
             */
            if( state.root && state.url == '' ) {
                return;
            }

            /*
             * if the URL is nothing then close popups if one was set
             */
            if( state.url === '' ){
                popupIsActive = false;
                popup.close(true);
                this.closeGraph(true);
                return;
            }

            /*
             * player profile
             */
            let playerProfileUrl = /^player-profile\/([a-z-]+)\/(\d+)$/;
            let playerProfileMatches = state.url.match(playerProfileUrl);
            if( playerProfileMatches && playerProfileMatches.length === 3 ) {
                // if this wasn't a push (i.e. user click) then load the popup
                if( ! state.pushed ) {
                    playerProfile.load({ id: playerProfileMatches[2], name: playerProfileMatches[1] }, true)
                }
                return;
            }

            /*
             * results popout, rerun search if already set
             */

            let resultsUrl = /^results\/([\d,]+)\/(\-1|[(GK|FB|CB|DM|CM|AM|W|ST),]+)\/(\d+)\/(\d+)\/(\d+)\/(minutes|value)\/(\-1|[a-z]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([\d\.]+)\/([0-1])\/([0-1])\/([0-1])\/([0-1])?$/;
            let resultsMatches = state.url.match(resultsUrl);
            if( resultsMatches && resultsMatches.length === 20 ) {
                // if we came from a popup then do nothing else
                if( popupIsActive === true ) {
                    popupIsActive = false;
                    popup.close(true);
                    return;
                }

                // if we have just carried out a search then do nothing else
                if( state.pushed ) {
                    return;
                }

                // loading screen on as this will take a moment
                $c('appMain').loading = true;

                // set this to avoid flash of showing the filters, as graph will be loaded at the end
                // this.graphIsActive = true;

                // Update the labels in the select box components for season, stat 1, stat 2, dot size and foot
                $c('selectInputsSeason').label = $c('selectInputsSeason').items[
                    $c('selectInputsSeason').items.findIndex(i => i.value == resultsMatches[3])
                ].label;
                /// which labels depends on whether not not the position is GK
                if(resultsMatches[2] == 'GK') {
                    $c('selectInputsStat1IdGk').label = $c('selectInputsStat1IdGk').items[
                        $c('selectInputsStat1IdGk').items.findIndex(i => i.value == resultsMatches[4])
                    ].label;
                    $c('selectInputsStat2IdGk').label = $c('selectInputsStat2IdGk').items[
                        $c('selectInputsStat2IdGk').items.findIndex(i => i.value == resultsMatches[5])
                    ].label;
                } else {
                    $c('selectInputsStat1Id').label = $c('selectInputsStat1Id').items[
                        $c('selectInputsStat1Id').items.findIndex(i => i.value == resultsMatches[4])
                    ].label;
                    $c('selectInputsStat2Id').label = $c('selectInputsStat2Id').items[
                        $c('selectInputsStat2Id').items.findIndex(i => i.value == resultsMatches[5])
                    ].label;
                }
                $c('selectInputsDotSize').label = $c('selectInputsDotSize').items[
                    $c('selectInputsDotSize').items.findIndex(i => i.value == resultsMatches[6])
                ].label;
                // $c('selectInputsFoot').label = $c('selectInputsFoot').items[
                //     $c('selectInputsFoot').items.findIndex(i => i.value == resultsMatches[7])
                // ].label;

                let inputs = {
                    leagueIds: resultsMatches[1].includes(',') ? resultsMatches[1].split(',') : [resultsMatches[1]], // label will be set when leagues are loaded via ajax
                    position: resultsMatches[2].includes(',') ? resultsMatches[2].split(',') : [resultsMatches[2]],
                    season: resultsMatches[3],
                    dotSize: resultsMatches[6],
                    foot: resultsMatches[7],
                    age: { min: +resultsMatches[8], max: +resultsMatches[9] },
                    minutesPlayed: { min: +resultsMatches[10], max: +resultsMatches[11] },
                    value: { min: +resultsMatches[12], max: +resultsMatches[13] },
                    contractLength: { min: +resultsMatches[14], max: +resultsMatches[15] },
                    gbeEligible: parseInt(resultsMatches[16]), // must be 0 or 1, not a string
                    gbePotential: parseInt(resultsMatches[17]), // must be 0 or 1, not a string
                    gbeIneligible: parseInt(resultsMatches[18]), // must be 0 or 1, not a string
                    euPassport: parseInt(resultsMatches[19]), // must be 0 or 1, not a string
                    internationalApps: parseInt(resultsMatches[20]), // must be 0 or 1, not a string
                }

                // add in stats depending on whether not not the position is GK
                if(resultsMatches[2] == 'GK') {
                    inputs = {
                        ...inputs,
                        stat1IdGk: +resultsMatches[4],
                        stat2IdGk: +resultsMatches[5],
                        stat1Id: 0,
                        stat12d: 0,
                    }
                } else {
                    inputs = {
                        ...inputs,
                        stat1IdGk: 0,
                        stat12dGk: 0,
                        stat1Id: +resultsMatches[4],
                        stat2Id: +resultsMatches[5],
                    }
                }

                this.$store.inputs.current = {...inputs};

                // update position labels/items
                $c('checkboxSelectInputsPosition').updateSelectedItems();
                this.handlePositionChanges();

                this.loadGraph();
            }
        },

        init: function() {

            // initialise global filters
            Spruce.store('inputs', {
                current: {},
                defaults: {
                    leagueIds: [],
                    position: [],
                    positionTotal: 0,
                    season: 0,
                    stat1Id: 0,
                    stat2Id: 0,
                    dotSize: '',
                    age: { min: 15, max: 35 },
                    value: { min: 0, max: 150 },
                    minutesPlayed: { min: 50, max: 3000 },
                    contractLength: { min: 0, max: 3.5 },
                    foot: -1,
                    gbeEligible: 1,
                    gbePotential: 1,
                    gbeIneligible: 1,
                    euPassport: 0,
                    internationalApps: 0,
                },
                set(key, value) {
                    this.current[key] = value;
                },
                reset() {
                    this.current = {...this.defaults};
                    // console.log(this.current)
                }
            });
            this.$store.inputs.reset();

            //default labels, and some values
            this.$nextTick(() => {
                // set the initial foot label
                // if(this.$store.inputs.current.foot == -1) {
                //     $c('selectInputsFoot').label = $c('selectInputsFoot').items[0].label;
                // }

                // set the initial season label and value
                if(this.$store.inputs.current.season == 0) {
                    this.$store.inputs.current.season = $c('selectInputsSeason').items[0].value;
                    $c('selectInputsSeason').label = $c('selectInputsSeason').items[0].label;
                }
            });

            // basic routing for this page
            Spruce.watch('history', state => this.router(state));

            // sliders
            this.$nextTick( () => {
                sliders.init('age', {
                    start: [+this.$store.inputs.current.age.min, +this.$store.inputs.current.age.max],
                    connect: true,
                    step: 2,
                    margin: 2,
                    range: { min: 15, max: 35 }
                });
                // sliders.init('value', {
                //     start: [+this.$store.inputs.current.value.min, +this.$store.inputs.current.value.max],
                //     // start: [0, 100],
                //     connect: true,
                //     step: 1,
                //     margin: 1,
                //     range: {
                //         'min': [0,   0.025000],
                //         '5%':  [0.1, 0.050000],
                //         '25%': [1,   0.100000],
                //         '80%': [10,  1.000000],
                //         'max': [150.000000]
                //     },
                //     format: wNumb({
                //         decimals: 3
                //     })
                // });
                sliders.init('minutesPlayed', {
                    start: [+this.$store.inputs.current.minutesPlayed.min, +this.$store.inputs.current.minutesPlayed.max],
                    connect: true,
                    step: 50,
                    margin: 50,
                    range: { min: 50, max: 3000 }
                });
                // sliders.init('contractLength', {
                //     start: [+this.$store.inputs.current.contractLength.min, +this.$store.inputs.current.contractLength.max],
                //     connect: true,
                //     step: 0.5,
                //     margin: 0.5,
                //     range: { min: 0, max: 3.5 }
                // });
            });

            // handle position changes
            this.$nextTick( () => {
                window.dispatchEvent(new CustomEvent('register-on-change', {
                    detail: {
                        id: 'checkboxSelectInputsPosition',
                        callback: this.handlePositionChanges,
                    }
                }))
            })

            // DEV ONLY
            // this.$nextTick(() => {
                // this.graphData = testScatterGraphData;
                // this.$store.inputs.current.leagueIds = [364];
                // this.$store.inputs.current.position = ["GK"];
                // this.$store.inputs.current.stat1IdGk = 41;
                // this.$store.inputs.current.stat2IdGk = 42;
                // this.$store.inputs.current.foot = -1;
                // this.$store.inputs.current.dotSize = 'value';
                // this.openGraph();
                // this.activePlayer = this.graphData.players[0];
            // })
        },

        // runs when the position checkbox select component changes, and enforces the logic for
        // all positions, goalkeepers and outfield players, including updating the store and label
        handlePositionChanges: function() {

            // work with an object to stop Alpine refreshing each time it changes
            let p = [...this.$store.inputs.current.position];

            // ensure for positions:
            // if all positions (represented by -1) is selected then clear the others
            if(p[p.length-1] == -1) {
                p = [-1];

            // if something else is selected ...
            } else {

                // remove 'all positions'
                p = p.filter( v => v != -1 );

                // if GK is selected then clear the others
                if(p[p.length-1] == 'GK') {
                    p = ['GK'];

                // if an outfield position is selected then clear GK
                } else {
                    p = p.filter( v => v != 'GK' );
                }
            }

            // update label
            let label;

            // no position selected, so back to initial
            if(p.length == 0) {
                label = $c('checkboxSelectInputsPosition').initialLabel;

            // just one position, so show the name
            } else if(p.length == 1) {
                label = $c('checkboxSelectInputsPosition').items[$c('checkboxSelectInputsPosition').items.findIndex(i => i.value == p[0])].label

            // multiple positions, so show a summary
            } else {
                label = getLang('multiple_positions', {'%COUNT%': p.length});
            }

            // update the label
            $c('checkboxSelectInputsPosition').label = label;

            // update store
            this.$store.inputs.set('position', p);
            this.$store.inputs.set('positionTotal', p.length);
        },

        /*
         * Check if all inputs are valid, before the generate button becomes enabled.
         */
        isValid: function() {
            if(this.$store.inputs.current.leagueIds.length == 0) {
                return false;
            }
            if(this.$store.inputs.current.position.length == 0) {
                return false;
            }
            if(this.$store.inputs.current.season == 0) {
                return false;
            }
            if(this.$store.inputs.current.position[0] == 'GK') {
                if(this.$store.inputs.current.stat1IdGk == 0 || this.$store.inputs.current.stat2IdGk == 0) {
                    return false;
                }
                if(this.$store.inputs.current.stat1IdGk == this.$store.inputs.current.stat2IdGk) {
                    return false;
                }
            } else {
                if(this.$store.inputs.current.stat1Id == 0 || this.$store.inputs.current.stat2Id == 0) {
                    return false;
                }
                if(this.$store.inputs.current.stat1Id == this.$store.inputs.current.stat2Id) {
                    return false;
                }
            }
            if(this.$store.inputs.current.dotSize == '') {
                return false;
            }
            if(this.$store.inputs.current.foot == '') {
                return false;
            }
            return true;
        },

        /*
         * Once parameters have been set, load a list of matching players into a popout.
         *
         * This is triggered by the Get Scatter Graph button.
         */
        loadGraph: function() {
            // initialise the save comparison component
            window.dispatchEvent(new CustomEvent('init-save-scatter-graph'));

            // hide the league filter
            $c('selectLeagueId').expanded = false;

            // Show the loading notice
            this.$store.loading = true;

            // Load player matches, passing the player ID and global filters
            let params = {
                league_id: this.$store.inputs.current.leagueIds.join(','),
                position: this.$store.inputs.current.position.join(','),
                season: this.$store.inputs.current.season,
                stat_1: this.$store.inputs.current.position[0] == 'GK' ? this.$store.inputs.current.stat1IdGk : this.$store.inputs.current.stat1Id,
                stat_2: this.$store.inputs.current.position[0] == 'GK' ? this.$store.inputs.current.stat2IdGk : this.$store.inputs.current.stat2Id,
                dot_size: this.$store.inputs.current.dotSize,
                foot: this.$store.inputs.current.foot,
                age_min: this.$store.inputs.current.age.min,
                age_max: this.$store.inputs.current.age.max,
                minutes_played_min: this.$store.inputs.current.minutesPlayed.min,
                minutes_played_max: this.$store.inputs.current.minutesPlayed.max,
                value_min: this.$store.inputs.current.value.min,
                value_max: this.$store.inputs.current.value.max,
                contract_length_min: this.$store.inputs.current.contractLength.min,
                contract_length_max: this.$store.inputs.current.contractLength.max,
                gbe_eligible: this.$store.inputs.current.gbeEligible,
                gbe_potential: this.$store.inputs.current.gbePotential,
                gbe_ineligible: this.$store.inputs.current.gbeIneligible,
                eu_passport: this.$store.inputs.current.euPassport,
                international_apps: this.$store.inputs.current.internationalApps,
            }

            axios.get('/api/scatter-graph/', { params })
                .then( response => {

                    // Hide the loading notices
                    this.$store.loading = false;
                    $c('appMain').loading = false;

                    // if no results then show an error and return
                    if( response.data.length === 0 ) {
                        modal(getLang('find_players_no_results'));
                        return;
                    } else {

                        // Save the results
                        this.graphData = Object.create( response.data );

                        // Show the results popout
                        this.openGraph();

                        // Add this state to history
                        let stats = [];
                        if(this.$store.inputs.current.position[0] == 'GK') {
                            stats = [
                                this.$store.inputs.current.stat1IdGk,
                                this.$store.inputs.current.stat2IdGk,
                            ]
                        } else {
                            stats = [
                                this.$store.inputs.current.stat1Id,
                                this.$store.inputs.current.stat2Id,
                            ]
                        }
                        let path = buildPath([
                            'results',
                            this.$store.inputs.current.leagueIds.join(','),
                            this.$store.inputs.current.position.join(','),
                            this.$store.inputs.current.season,
                            ...stats,
                            this.$store.inputs.current.dotSize,
                            this.$store.inputs.current.foot,
                            this.$store.inputs.current.age.min,
                            this.$store.inputs.current.age.max,
                            this.$store.inputs.current.minutesPlayed.min,
                            this.$store.inputs.current.minutesPlayed.max,
                            this.$store.inputs.current.value.min,
                            this.$store.inputs.current.value.max,
                            this.$store.inputs.current.contractLength.min,
                            this.$store.inputs.current.contractLength.max,
                            this.$store.inputs.current.gbeEligible,
                            this.$store.inputs.current.gbePotential,
                            this.$store.inputs.current.gbeIneligible,
                            this.$store.inputs.current.euPassport,
                            this.$store.inputs.current.internationalApps,
                        ]);

                        // only push to history if this is different, else replace
                        if( path != this.$store.history.url ) {
                            historyManager.push(path, {});
                        } else {
                            historyManager.replace(path, {});
                        }
                    }

                })
                .catch( response => {
                    modal(getLang('generic_error'));

                    // Hide the loading notice
                    this.$store.loading = false;

                    this.closeGraph()
                })
        },

        /*
         * Opens the graph popout.
         *
         */
        openGraph: function() {
            //open the graph popout
            this.graphIsActive = true;
        },

        /*
         * Close the graph popout.
         *
         * This is triggered by the Back To Search button.
         */
        closeGraph: function(fromRouter) {
            //close the graph popout
            this.graphIsActive = false;
            this.graphData = null;

            //reset the history state
            if( ! fromRouter ) {
                historyManager.reset();
            }
        },
    }
};
